var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("出庫元データの選択")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.not_exit_entries,"no-data-text":"データはありません"},on:{"click:row":_vm.clickRow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }